/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark, primary, grey, white } = colors;

export default {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  "::selection": {
    backgroundColor: primary.main,
    color: white.main,
  },
  body: {
    color: dark.main,
    textRendering: "optimizeLegibility",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
  },
  img: {
    maxWidth: "100%",
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  ".post-title, .entry-title": {
    color: dark.main,
    fontFamily: '"Roboto Slab", "Georgia", serif',
    fontSize: "clamp(1.75rem, 4vw, 2.75rem)",
    lineHeight: 1.15,
    marginBottom: "1.5rem",
    letterSpacing: "-0.04em",
  },
  ".post-body, .entry-content": {
    color: dark.main,
    fontSize: "clamp(0.95rem, 1.2vw, 1.05rem)",
    lineHeight: 1.85,
    overflowX: "auto",
  },
  ".post-body .MsoNormal, .entry-content .MsoNormal": {
    marginBottom: "0.85rem",
    lineHeight: 1.85,
  },
  ".post-body b, .entry-content b": {
    color: "#24324a",
    fontWeight: 700,
  },
  ".post-body ul, .post-body ol, .entry-content ul, .entry-content ol": {
    paddingLeft: "1.5rem",
    margin: "0.75rem 0 1.25rem",
  },
  ".post-body li, .entry-content li": {
    marginBottom: "0.5rem",
    paddingLeft: "0.2rem",
  },
  ".post-body table, .entry-content table": {
    borderCollapse: "separate",
    borderSpacing: 0,
    minWidth: "640px",
    width: "100%",
    margin: "1.25rem 0 2rem",
    overflow: "hidden",
    border: `1px solid ${grey[300]}`,
    borderRadius: "18px",
    backgroundColor: "rgba(255,255,255,0.86)",
    boxShadow: "0 20px 55px rgba(22, 30, 48, 0.08)",
  },
  ".post-body td, .entry-content td": {
    borderColor: `${grey[300]} !important`,
    padding: "0.85rem 1rem",
    verticalAlign: "middle",
  },
  ".post-body tr:first-of-type td, .entry-content tr:first-of-type td": {
    backgroundColor: "rgba(62, 161, 236, 0.08)",
    color: dark.main,
  },
};
